import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import useFormat from "../../hooks/utils/useFormat";
import colorFromIndex from "../../hooks/utils/colorFromIndex";

const ChartsKpi = props => {
  const { label, value } = props;

  return (
    <div className={style.kpi}>
      <span className={style.kpiValue}>{value}</span>
      {!!label && <span className={style.kpiLabel}>{label}</span>}
    </div>
  );
};

const ChartsLegend = props => {
  const { reports, format_value = "", total = 0, hover, onHover, hideValue = false } = props;
  const { formatReal } = useFormat();

  return (
    <div className={style.labels}>
      {reports?.map((__report, __report_i) => {
        const _value = Number(__report?.value || 0);
        const _value_formated =
          format_value === "real" ? formatReal(_value) : _value % 1 !== 0 ? _value.toFixed(2) : _value;
        const _value_percent = `${(_value ? (_value / total) * 100 : 0).toFixed(2)}%`;

        return (
          <div
            className={`${style.label} ${hover === __report_i ? "hover" : ""}`}
            onMouseOver={() => onHover?.(__report_i)}
            onMouseLeave={() => onHover?.(-1)}
            style={{ opacity: hideValue || __report.value > 0 ? "1" : ".333" }}
          >
            <span
              style={{ background: __report?.color || colorFromIndex(__report_i) }}
              className={style.circle}
            ></span>
            <span className={style.labelTxt}>{__report.label}</span>
            {!hideValue && (
              <span className={style.smallLabel}>
                {_value_formated} ({_value_percent})
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

const ChartsTooltipCard = props => {
  const { label, value, percent, color } = props;

  return (
    <div className={style.toolTipContent}>
      <p>
        <span style={{ background: color }} className={style.circle}></span>
      </p>
      <p>
        <span className={style.labelTxt}>{label}</span>
      </p>
      <p>
        <span className={style.smallLabel}>
          {value} ({percent})
        </span>
      </p>
    </div>
  );
};

const ChartsTooltipMultiCard = props => {
  const { title, items } = props;

  return (
    <div className={style.toolTipContent}>
      {title && (
        <p>
          <span className={style.labelTxt}>{title}</span>
        </p>
      )}
      {items?.map((__item, __i) => (
        <p key={__i}>
          <span style={{ background: __item.color }} className={style.circle}></span>
          <span className={style.labelTxt}>{__item.label}</span>{" "}
          <span className={style.smallLabel}>{__item.value}</span>
        </p>
      ))}
    </div>
  );
};

const ChartsBar = props => {
  const { title, type, reports, format_value = "" } = props;
  const { formatReal } = useFormat();

  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (reports) {
      let totalVar = 0;
      reports.forEach(__report => {
        totalVar += __report.value || 0;
      });
      setTotal(totalVar || 0);
    }
  }, [reports]);

  // Temp Generator
  const [hover, setHover] = useState();

  return (
    <>
      <div className={`${style.ChartsBar} mt-4`}>
        <div className={style.header}>
          {!!title ? <h4>{title}</h4> : <span></span>}
          <span>{`Total: ${format_value === "real" ? formatReal(total) : total?.toFixed(2)} ${type}`}</span>
        </div>
        <div className={style.reportChart}>
          <div>
            <div>
              <div className={style.bars}>
                {reports.map(
                  (__report, __report_i) =>
                    !!__report.value && (
                      <div
                        style={{ flexGrow: __report.value, background: __report?.color || colorFromIndex(__report_i) }}
                        onMouseOver={() => setHover(__report_i)}
                        onMouseLeave={() => setHover(-1)}
                        className={`${style.singleBar} ${hover === __report_i ? "hover" : ""}`}
                      >
                        <div className={style.toolTip}>
                          <ChartsTooltipCard
                            label={__report.label}
                            value={format_value === "real" ? formatReal(__report.value) : __report.value.toFixed(2)}
                            percent={`${(__report.value ? (__report.value / total) * 100 : 0).toFixed(2)}%`}
                            color={__report?.color || colorFromIndex(__report_i)}
                          />
                        </div>
                      </div>
                    ),
                )}
              </div>
              <ChartsLegend reports={reports} format_value={format_value} total={total} hover={hover} onHover={setHover} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { ChartsBar, ChartsLegend, ChartsTooltipCard, ChartsTooltipMultiCard, ChartsKpi };
